import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/base/SEOSchema';
import FadeIn from '@/components/base/FadeIn';
import HeroSection from './components/HeroSection';
import { QuickAnswerBox, WhyUseSection, StatsSection, CategoriesGrid, PopularBrands, HowItWorks } from './components/HomeContent';
import { ComparisonTables, BuyingGuide, SafetyGuide, EEATSection } from './components/HomeGuides';
import FAQSection from './components/FAQSection';
import { MidCTA, ArticlePreview, FooterCTA } from './components/HomeCTA';

export default function Home() {
  return (
    <>
      <SEOSchema type="homepage" />
      <Navbar />
      <main>
        <HeroSection />
        <FadeIn><QuickAnswerBox /></FadeIn>
        <FadeIn><WhyUseSection /></FadeIn>
        <FadeIn><StatsSection /></FadeIn>
        <FadeIn><MidCTA /></FadeIn>
        <FadeIn><CategoriesGrid /></FadeIn>
        <FadeIn><PopularBrands /></FadeIn>
        <FadeIn><HowItWorks /></FadeIn>
        <FadeIn><ComparisonTables /></FadeIn>
        <FadeIn><BuyingGuide /></FadeIn>
        <FadeIn><SafetyGuide /></FadeIn>
        <FadeIn><ArticlePreview /></FadeIn>
        <FadeIn><FAQSection /></FadeIn>
        <FadeIn><EEATSection /></FadeIn>
        <FadeIn><FooterCTA /></FadeIn>
      </main>
      <Footer />
    </>
  );
}